import * as React from 'react';
import { StudyCoughEventType } from 'webportalclient';
import { EditModeEnum } from '../interfaces/state';

interface EventTypeSelectorProps {
    isVisible: boolean;
    events: Array<StudyCoughEventType>
    eventSelected: StudyCoughEventType;
    isEditMode: EditModeEnum;
    onChange?: (event: StudyCoughEventType) => void;
}

export const EventTypeSelector = (props: EventTypeSelectorProps) => {
    const onChange = (value) => {
        props.onChange(props.events.filter(x => x.id == value)[0]);
    }

    if (props.events && props.events.length > 0 && props.isVisible) {
        const selectedVal = props.eventSelected ? props.eventSelected.id : props.events[0].id;
        const defaultColour = props.eventSelected ? props.eventSelected.colour : '#ffffff';

        return (
            <select id="EventType" style={{ height: 34 + 'px', color: defaultColour }} className="form-control" value={selectedVal} onChange={(e) => { onChange(e.target.value); e.target.blur(); }} disabled={props.isEditMode !== EditModeEnum.NotEditing}>
                {props.events.map(x => {
                    return (<option style={{ color: x.colour }} key={x.id} value={x.id}>
                        {x.name}
                    </option>);
                })}
            </select>
        );
    } else {
        return null;
    }
}
